import type { IconProps } from './IconProps';

export const MatchaGreenIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 33 33"
    fill="none"
    width={props.width ?? 33}
    height={props.height ?? 33}
    {...props}
  >
    <g filter="url(#filter0_i_4295_27699)">
      <path
        d="M24.3672 3.829C24.3046 3.95411 24.1547 4.00754 24.027 3.9502C22.1282 3.08613 19.8201 2.7942 18.3031 2.7942C12.8489 2.7942 7.39343 5.45417 7.39343 9.82663C7.39343 12.1712 9.15153 14.1548 11.7216 14.1548C14.5614 14.1548 16.6805 12.0813 18.393 10.1876C19.9256 8.47514 21.7294 6.58149 24.2981 6.58149C27.0936 6.58149 29.1215 8.65499 29.1215 11.4505C29.1215 15.8686 23.8015 20.8275 16.4537 20.8275C9.10592 20.8275 3.78729 16.9047 3.78729 11.4505C3.78729 6.35603 9.82793 1.75811 16.455 1.75811C19.837 1.75811 22.3836 2.46708 24.2577 3.48363C24.3815 3.5514 24.4297 3.70388 24.3672 3.8303V3.829ZM16.455 0C7.39343 0 0 7.39343 0 16.455C0 25.5166 7.39343 33 16.455 33C25.5166 33 33 25.6066 33 16.455C33 7.3035 25.6053 0 16.455 0Z"
        fill="url(#paint0_linear_4295_27699)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_4295_27699"
        x="0"
        y="0"
        width="33"
        height="34"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4295_27699" />
      </filter>
      <linearGradient
        id="paint0_linear_4295_27699"
        x1="7"
        y1="8.12791e-08"
        x2="16.5"
        y2="33"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B96D" />
        <stop offset="1" stopColor="#86D985" />
      </linearGradient>
    </defs>
  </svg>
);
